import React from 'react';
import { isQuarter } from '@domain/_screens/overview/segmented/graph/segmented.utils';
import { METRICS_TYPES } from '@shared/constants/MetricsTypeConstants';
import { SEGMENTATIONS } from '@domain/_screens/overview/segmented/constants';
import { formatValuesForDisplayBasedOnType } from '@shared/utils/strings';
import { format } from '@shared/wrappers/date/date';
import { DATE_FORMAT_BY_SEGMENTATION } from '@shared/utils/date';
import {
    ColorIndicator,
    Hotspottext,
    MetricName,
    ToolTipTitle,
    TooltipWholeText,
} from './segmented-tooltip.styles';
import { SegmentedTooltipProps } from './segmented-tooltip.types';
import { DAY_OF_WEEK_FORMAT } from './segmented-tooltip.constants';

export const SegmentedTooltip = ({
    metrics, hotspots, currencySymbol, segmentation,
}: SegmentedTooltipProps) => (
    <TooltipWholeText>
        {!(!metrics[0].value && !metrics[1].value)
            ? metrics
                .map((metric) => {
                    const formattedDate = () => {
                        if (segmentation === SEGMENTATIONS.HOUR) {
                            return metric.type === METRICS_TYPES.comparison ? ''
                                : metric.date;
                        }
                        if (isQuarter(segmentation)) return metric.date;
                        return metric.date === ''
                            ? ''
                            : format(
                                metric.date,
                                `${segmentation === SEGMENTATIONS.DATE
                                    ? DAY_OF_WEEK_FORMAT
                                    : ''}${DATE_FORMAT_BY_SEGMENTATION[segmentation]}`,
                            );
                    };
                    return (
                        <div key={`segmented-tooltip-metric-${metric.label}`}>
                            <ToolTipTitle>
                                {formattedDate()}
                            </ToolTipTitle>

                            <ColorIndicator color={metric.color} />
                            <MetricName> {` ${metric.label}:`} </MetricName>
                            {formatValuesForDisplayBasedOnType(
                                metric.value, metric.type, currencySymbol,
                            )}
                        </div>
                    );
                }) : 'No data'}
        <Hotspottext>
            {hotspots.length > 0 && <ToolTipTitle> HotSpots </ToolTipTitle>}
            {hotspots.map(hotspot => (
                <div>
                    {hotspot.title}
                </div>
            ))}
        </Hotspottext>
    </TooltipWholeText>
);

SegmentedTooltip.defaultProps = {
    hotspots: [],
};
